import Marquee from "react-fast-marquee";

const ITEMS = [
  "UPSCALE CONCRETE SERVICES",
  "SYDNEY NSW",
  "ROPES CROSSING",
  "QUALITY WORK · HONEST PRICE",
  "DRIVEWAYS",
  "DECORATIVE CONCRETE",
  "POOL SURROUNDS",
];

export default function Ribbon({ dark = true }) {
  return (
    <div
      className={`py-4 border-y ${dark ? "bg-concrete-900 border-concrete-900" : "bg-background border-black/10"}`}
      data-testid="marquee-ribbon"
    >
      <Marquee speed={40} gradient={false} autoFill>
        {ITEMS.map((t, i) => (
          <span key={i} className="flex items-center">
            <span
              className={`font-display font-bold uppercase tracking-tight text-2xl sm:text-4xl mx-6 ${
                dark ? "text-white" : "text-concrete-900"
              }`}
            >
              {t}
            </span>
            <span className={`text-2xl sm:text-4xl ${dark ? "text-concrete-500" : "text-concrete-300"}`}>✦</span>
          </span>
        ))}
      </Marquee>
    </div>
  );
}
